<div class="access-card" [class.expanded]="expanded">
  <div class="card-header" (click)="toggleExpanded()">
    <div class="card-title">
      <div
        class="title-icon"
        [class.success]="successfullyConnected"
        [class.info]="needsCloudFormationMigration || showMigrationDuringTest"
      >
        <i *ngIf="successfullyConnected" class="fa-solid fa-check"></i>
        <i
          *ngIf="needsCloudFormationMigration || showMigrationDuringTest"
          class="fa-solid fa-arrow-right-arrow-left"
        ></i>
        <i
          *ngIf="
            !successfullyConnected &&
            !needsCloudFormationMigration &&
            !showMigrationDuringTest &&
            accessType === 'source'
          "
          class="fa-solid fa-location-dot"
        ></i>
        <i
          *ngIf="
            !successfullyConnected &&
            !needsCloudFormationMigration &&
            !showMigrationDuringTest &&
            accessType === 'target'
          "
          class="fa-solid fa-location-crosshairs"
        ></i>
        <i
          *ngIf="
            !successfullyConnected &&
            !needsCloudFormationMigration &&
            !showMigrationDuringTest &&
            accessType === 'failback'
          "
          class="fa-solid fa-rotate-left"
        ></i>
      </div>
      <div>
        <h3>{{ title }}</h3>
        <div class="card-subtitle">
          <code>{{ awsAccountId }}</code> / <code>{{ region }}</code>
        </div>
      </div>
    </div>
    <div class="card-actions">
      <div class="card-action" (click)="$event.stopPropagation()">
        <ng-container *ngIf="successfullyConnected">
          <span class="success-badge"><i class="fa-solid fa-circle-check"></i> Connected</span>
        </ng-container>
        <ng-container *ngIf="needsCloudFormationMigration || showMigrationDuringTest">
          <span class="info-badge"><i class="fa-solid fa-circle-info"></i> Action Required</span>
        </ng-container>
        <ng-container *ngIf="!successfullyConnected && !needsCloudFormationMigration && !showMigrationDuringTest">
          <button class="arpio-button" [disabled]="testing" (click)="testButtonClick()">
            <ng-container *ngIf="testing; else notTestingBlock">
              <i class="fa-solid fa-spinner fa-spin"></i> TESTING...
            </ng-container>
            <ng-template #notTestingBlock>TEST ACCESS</ng-template>
          </button>
        </ng-container>
      </div>
      <i class="fa-solid chevron-icon" [class.fa-chevron-down]="expanded" [class.fa-chevron-right]="!expanded"></i>
    </div>
  </div>

  <!-- Body: Not connected - needs setup -->
  <div
    class="card-body-wrapper"
    *ngIf="!successfullyConnected && !needsCloudFormationMigration && !showMigrationDuringTest"
    [@slideDown]="expanded ? 'expanded' : 'collapsed'"
  >
    <div class="card-body">
      <p class="instruction-text">
        <ng-container *ngIf="stackName; else noStackNameBlock">
          <strong *ngIf="retryText && !testing" class="retry-text">{{ retryText }}</strong> Update the CloudFormation
          stack <strong>{{ stackName }}</strong> with this template:
        </ng-container>
        <ng-template #noStackNameBlock>
          <ng-container *ngIf="connectSuccess; else noAccessBlock">
            <strong *ngIf="retryText && !testing" class="retry-text">{{ retryText }}</strong> Update the
            {{ uiService.productName }} CloudFormation stack with this template:
          </ng-container>
          <ng-template #noAccessBlock>
            <strong *ngIf="retryText && !testing" class="retry-text">{{ retryText }}</strong> Create a new
            CloudFormation stack from this template:
          </ng-template>
        </ng-template>
      </p>

      <div class="command-block">
        <button class="copy-btn" [copy-clipboard]="templateUrl" (copied)="onCopied()">
          <i class="fa-utility fa-semibold" [class.fa-copy]="!copied" [class.fa-check]="copied"></i>
          {{ copied ? 'Copied!' : 'Copy URL' }}
        </button>
        <pre><code>{{ templateName }}</code></pre>
      </div>

      <p class="help-text">
        <a [href]="templateUrl" target="_blank" class="download-link">
          <i class="fa-solid fa-download"></i> Download {{ templateName }}
        </a>
      </p>
    </div>
  </div>

  <!-- Body: Needs CloudFormation migration (currently via StackSets) -->
  <div
    class="card-body-wrapper"
    *ngIf="needsCloudFormationMigration || showMigrationDuringTest"
    [@slideDown]="expanded ? 'expanded' : 'collapsed'"
  >
    <div class="card-body">
      <div class="info-message">
        <i class="fa-solid fa-circle-info"></i>
        <span
          >Access is currently provided by StackSets. Deploy this CloudFormation template to switch to standalone
          management.</span
        >
      </div>

      <div class="notice-block">
        <div class="notice-text">
          <strong *ngIf="retryText && !testing" class="retry-text">{{ retryText }}</strong>
          <span>After deploying the CloudFormation template, verify access is configured:</span>
        </div>
        <button class="arpio-button" [disabled]="testing" (click)="testButtonClick()">
          <ng-container *ngIf="testing; else notTestingMigration">
            <i class="fa-solid fa-spinner fa-spin"></i> TESTING...
          </ng-container>
          <ng-template #notTestingMigration>TEST ACCESS</ng-template>
        </button>
      </div>

      <div class="command-block">
        <button class="copy-btn" [copy-clipboard]="templateUrl" (copied)="onCopied()">
          <i class="fa-utility fa-semibold" [class.fa-copy]="!copied" [class.fa-check]="copied"></i>
          {{ copied ? 'Copied!' : 'Copy URL' }}
        </button>
        <pre><code>{{ templateName }}</code></pre>
      </div>

      <p class="help-text">
        <a [href]="templateUrl" target="_blank" class="download-link">
          <i class="fa-solid fa-download"></i> Download {{ templateName }}
        </a>
      </p>
    </div>
  </div>

  <!-- Body: Successfully connected via CloudFormation -->
  <div class="card-body-wrapper" *ngIf="successfullyConnected" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
    <div class="card-body success-body">
      <div class="success-message">
        <i class="fa-solid fa-circle-check"></i>
        <span>Access configured via CloudFormation</span>
      </div>
    </div>
  </div>
</div>
